namespace Portico.Models.Legacy {
	export type enrollmentInputType = EnrollmentResultModel;

	export interface ILegacy {
		enrollmentInput: enrollmentInputType; // todo: try to avoid doing this? this doesn't appear to be used anywhere.
		enrollmentInputEdit: enrollmentInputType; // todo: try to avoid doing this? this doesn't appear to be used anywhere.
	}

	export class Legacy implements ILegacy {
		enrollmentInput: enrollmentInputType;
		enrollmentInputEdit: enrollmentInputType;

		constructor(obj?: ILegacy) {
			if (obj) {
			}
		}
	}
}
